// @ts-nocheck
import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';

// import { ControllerValidationBarrament } from '../input-text/controller-validation-barrament';
// import { InputFieldErrorDirective } from '../input-text/error-overlay/error-overlay.directive';
import { Overlay } from '@angular/cdk/overlay';
import { NgClass, NgStyle } from '@angular/common';
import { IconComponent } from '@lbca-shared/icon';
import { ErrorOverlayClass } from '../../error-overlay/error-overlay.directive';
import {
  PopupFeedbackDirective,
  PopupInterfaceCommunication,
} from '../../popup-feedback/popup-feedback.directive';
@Component({
  selector: 'lbca-textarea',
  templateUrl: './textarea.component.html',
  styleUrl: './textarea.component.scss',
  imports: [NgStyle, NgClass, IconComponent],
})
export class TextareaComponent {
  private overlay = inject(Overlay);

  private popupFeedController = new PopupInterfaceCommunication();
  @HostBinding('attr.lbcaPopupFeedback') popupFeedback = new PopupFeedbackDirective(
    this.overlay,
    this.popupFeedController
  );

  @ViewChild('templateCopy') templateCopy!: TemplateRef<any>;

  private errorPopup!: ErrorOverlayClass;
  @ViewChild('inputData', { static: true }) inputData!: ElementRef;

  public hasMask: boolean = false;

  public isTouched: boolean = false;
  public hasError: boolean = false;
  public isRequired: boolean = false;
  public isDisabled: boolean = false;
  public isEditable: boolean = false;
  public isReadOnly: boolean = false;
  public isValidIcon: boolean = false;
  public isLabeled: boolean = false;
  public isTabeled: boolean = false;
  public copy: boolean = true;

  public labelValue: string = '';
  public helperTextValue: string = '';
  public placeholder: string = '';

  public maskIcon: any = null;

  public inputComponetIconStyle: any = null;
  public inputComponetIconSize: 'sm' | 'normal' = 'normal';
  public inputComponetHelperIconStyle: any = null;
  public componentFilling: any = null;

  public valueToReturn: any = '';

  private readInputTimeOutDebounce: any = null;

  public maxChars!: number;
  public minChars!: number;
  public enableCount: boolean = true;
  // public count: number =  0;
  public totalLines: number = 10;
  public type: 'countup' | 'countdown' = 'countdown';
  public errorCtrl: boolean = false;
  public limitFeedback = '';

  public inputComponetHelperIconLeftStyle: any = null;

  constructor() {
    const overlay = this.overlay;
    const elementRef = inject(ElementRef);

    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ],
      0,
      0,
      'top',
      'end'
    );
  }

  @Input() set tabeled(value: boolean) {
    this.isTabeled = value;
  }
  @Input('placeholder') set placeholderValue(value: string) {
    this.placeholder = value;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = !value;
  }
  @Input() set editable(value: boolean) {
    this.isEditable = value;
  }
  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set readonly(read: boolean) {
    this.isReadOnly = read;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set hasExternalError(value: boolean) {
    this.hasError = value;
  }
  @Input() set copyContent(value: boolean) {
    this.copy = value;
  }
  @Input() set componetIconStyle(icon: string) {
    this.inputComponetIconStyle = icon;
  }
  @Input() set componetHelperIconStyle(icon: string) {
    this.inputComponetHelperIconStyle = icon;
  }
  @Input() set componetIconSize(icon: 'sm' | 'normal') {
    this.inputComponetIconSize = icon;
  }
  @Input() set componetHelperIconLeftStyle(icon: string) {
    this.inputComponetHelperIconLeftStyle = icon;
  }

  @Input() set spacing(value: string) {
    this.componentFilling = value;
  }

  @Input() set rules(value: any) {
    if (value?.minSize) this.minChars = value.minSize;
    if (value?.maxSize) this.maxChars = value.maxSize;
  }
  @Input() set countType(val: 'countup' | 'countdown') {
    this.type = val;
  }
  @Input() set textCount(value: boolean) {
    this.enableCount = value;
  }
  @Input()
  set lines(value: number) {
    if (value < 4) value = 4;
    this.totalLines = value;
  }

  @Input('error')
  set err(error) {
    if (error && error.length > 0) {
      this.hasError = true;

      this.errorPopup.setErrors(error);
    } else {
      this.hasError = false;
      this.errorPopup.setErrors([]);
    }
  }

  @Input()
  set focus(value: boolean) {
    if (value) this.inputData!.nativeElement.focus();
  }

  fillValue!: string;

  @Input()
  set value(value) {
    if (value) {
      this.valueToReturn = value;
      this.isTouched = true;
      this.fillValue = value;
    }
  }

  @Output('changeValue') changeEmmiter = new EventEmitter();
  @Output('submitForm') submitActionEmmiter = new EventEmitter();
  @Output() focusState = new EventEmitter();
  @Output('setError') setErrorEmmiter = new EventEmitter();
  @Output('validStatus') validStatusEmmiter = new EventEmitter();

  public inputKeyUpEvent($event) {
    const value = $event.target.value;

    if (this.maxChars || this.minChars) this.limitFeedback = this.charsControl(value);

    clearTimeout(this.readInputTimeOutDebounce);

    this.hasError = false;
    this.isValidIcon = false;

    this.readInputTimeOutDebounce = setTimeout(() => {
      this.valueToReturn = value;

      if (this.valueToReturn) this.validStatusEmmiter.emit(true);
      else this.validStatusEmmiter.emit(false);
      this.changeEmmiter.emit(this.valueToReturn);

      if ($event.code)
        if ($event.code.substring(0, 5) === 'Enter') this.submitActionEmmiter.emit(true);
    }, 500);
  }

  public moveEndCursor() {
    setTimeout(() => {
      const range = document.createRange();
      const sel = getSelection()!;
      range.setStart(this.inputData!.nativeElement, 1);
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
    });
  }

  public click() {
    if (this.isEditable) {
      this.isLabeled = false;
      this.isTouched = true;
      this.focusState.emit(true);
    }
  }

  public copyPasteKeyUpEvent($event): void {
    this.hasError = false;
    this.isValidIcon = false;

    this.valueToReturn = $event.target.innerHTML;
    if (this.valueToReturn) this.validStatusEmmiter.emit(true);
    else this.validStatusEmmiter.emit(false);

    this.changeEmmiter.emit(this.valueToReturn);
  }

  public focusIn(): void {
    this.isTouched = true;
    this.focusState.emit(true);
    this.errorPopup.setFocus(true);
  }

  public focusOut(): void {
    setTimeout(async () => {
      if (!this.inputData!.nativeElement.value) this.isTouched = false;
      this.errorPopup.setFocus(false);
      if (this.isEditable) this.isLabeled = true;
    }, 100);
    this.focusState.emit(false);
  }

  public charsControl(input) {
    if (this.isDisabled) return undefined;

    const size = input.length || 0;
    let msg;

    if (this.maxChars) {
      const totalchars = this.maxChars - size;

      if (this.type === 'countdown') {
        if (totalchars < 0) {
          this.errorCtrl = true;
          msg = `Limite excedido em ${-totalchars} caracteres.`;
        } else if (this.minChars) {
          if (totalchars > this.maxChars - this.minChars) {
            this.errorCtrl = true;
            msg = `O texto deve conter ao menos ${this.minChars} caracteres.`;
          } else {
            this.errorCtrl = false;
            msg = totalchars;
          }
        } else {
          this.errorCtrl = false;
          msg = totalchars;
        }
      } else {
        if (size > this.maxChars) {
          this.errorCtrl = true;
          msg = `${this.maxChars - size} / ${this.maxChars}`;
        } else {
          this.errorCtrl = false;
          msg = `${size} / ${this.maxChars}`;
        }
      }
      return msg;
    } else if (this.minChars) {
      if (size < this.minChars) {
        this.errorCtrl = true;
        msg = `O texto deve conter ao menos ${this.minChars} caracteres.`;
      } else {
        this.errorCtrl = false;
        msg = `${size}`;
      }
      return msg;
    }
  }

  public copyToClipboard($event): void {
    $event.preventDefault();
    $event.stopPropagation();
    navigator.clipboard.writeText(this.inputData!.nativeElement.value).then(() => {
      this.popupFeedController.show(this.templateCopy);
      setTimeout(() => this.popupFeedController.close(), 4000);
    });
  }

  public preventDefault($event) {
    $event.preventDefault();
  }

  public stopPropagation($event) {
    $event.stopPropagation();
  }
}
